export default __webpack_public_path__ + "static/media/tour.dae87cdf.mp4";